import React from "react";

import { MigrationCountdown } from "components/design-system";
import { useMigrationCountdown } from "../../../hooks/useMigrationCountdown";

import * as styles from "./MigrationNoticeBanner.module.scss";

const PAYSTACK_MFB_URL = "https://paystackmfb.com/";

const MigrationNoticeBanner: React.FC = () => {
  const { isPast } = useMigrationCountdown();

  if (isPast) return null;

  return (
    <div className={styles.MigrationNoticeBanner} role="status">
      <div className={styles.MigrationNoticeBanner_container}>
        <p className={styles.MigrationNoticeBanner_message}>
          Brass Banking is moving to{" "}
          <a href={PAYSTACK_MFB_URL} target="_blank" rel="noreferrer">
            Paystack MFB
          </a>
          .
        </p>

        <MigrationCountdown variant="banner" />
      </div>
    </div>
  );
};

export default MigrationNoticeBanner;
